import { DeliveryMethod } from './types';

type DeliveryText = Record<DeliveryMethod, DeliveryTextItem>;
export interface DeliveryTextItem {
  name: string;
  title: string;
  subtitle: string;
  information?: string;
  description: string;
}

export const delivery: DeliveryText = {
  visit: {
    name: '직접수령',
    title: '모바일 앱에서 계속해 주세요',
    subtitle: '주변 약국에서 약 받기',
    description: `앱스토어, 구글 플레이스토어에서 '굿닥'을 검색하고 앱을 다운로드해 주세요.
    TV와 같은 방법으로 카카오톡 로그인을 계속 해주세요.
    로그인 후 진료 내역을 확인하고, 방문 수령을 선택해주세요.
    
    가까운 약국을 선택하여 처방약의 재고를 확인한 뒤 방문 수령을 해 주세요.`
  }
};
